import { createFileRoute, useParams } from '@tanstack/react-router';

import { RedFlagDetailScreen } from '@/features/red-flags/components/RedFlagDetailScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/red-flags/$id')({
  beforeLoad: () => {
    requirePermission('red_flag:read');
  },
  component: WorkspaceRedFlagDetailRoute,
  staticData: { crumb: 'Red flag' },
});

function WorkspaceRedFlagDetailRoute() {
  const { id } = useParams({ from: '/_staff/admin/workspace/red-flags/$id' });
  return <RedFlagDetailScreen flagId={id} />;
}
